import React, {useState} from 'react';

import {BlogsPageResult} from '../../../../server/routes/blog.js'

interface BlogsProps {
    server: string;
    pageData: unknown;
}

export default function Blogs({server, pageData}: BlogsProps) {

    const typedPageData = pageData as BlogsPageResult;
	let [data, setData] = useState(typedPageData);

	return (
        <>
            <div dangerouslySetInnerHTML={{__html:data.html}} />
        </>
    )
}
